<template>
  <div class="top-navigation">
    <div class="topnav-company-name">{{ $t("m.racernManagement") }}</div>
    <div class="navigation-box" style="float: right">
      <div class="language">
        <language-dropdown />
      </div>
      <div class="badgets">
        <el-badge :value="0" class="item" type="primary" :show-zero="false">
          <el-popover
            placement="bottom"
            :width="200"
            popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
          >
            <template #reference>
              <el-button plain type="primary">通知</el-button>
            </template>
            <template #default>
              <div style="color: grey">没有通知</div>
            </template>
          </el-popover>
        </el-badge>
        <el-badge :value="0" class="item" type="warning" :show-zero="false">
          <el-popover
            placement="bottom"
            :width="200"
            popper-style="box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
          >
            <template #reference>
              <el-button plain type="warning">警告</el-button>
            </template>
            <template #default>
              <div style="color: grey">没有警告</div>
            </template>
          </el-popover>
        </el-badge>
      </div>
      <div class="user-info">
        <user-info-dropdown />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";
import LanguageDropdown from "@/components/controller/LanguageDropdown.vue";
import UserInfoDropdown from "@/components/controller/UserInfoDropdown.vue";
import { useI18n } from "vue-i18n";
import router from "@/router";

// 模组注入部分
const { t } = useI18n();
// 搜索框部分
const inputState = ref("");

interface LinkItem {
  value: string;
  link: string;
}

const links = ref<LinkItem[]>([]);

const loadAll = () => {
  return [
    { value: t("r.overall"), link: "/overall" },
    { value: t("r.organization_list"), link: "/organization_list" },
    { value: t("r.ship_list"), link: "/ship_list" },
    { value: t("r.create_upgrade_plan"), link: "/create_upgrade_plan" },
    { value: t("r.upgrade_list"), link: "/upgrade_list" },
  ];
};

let timeout: ReturnType<typeof setTimeout>;
/* eslint-disable @typescript-eslint/no-explicit-any */
const querySearchAsync = (queryString: string, cb: (arg: any) => void) => {
  const results = queryString
    ? links.value.filter(createFilter(queryString))
    : links.value;

  clearTimeout(timeout);
  timeout = setTimeout(() => {
    cb(results);
  }, 3000 * Math.random());
};
const createFilter = (queryString: string) => {
  return (restaurant: LinkItem) => {
    return (
      restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    );
  };
};

const handleSelect = (item: Record<string, any>) => {
  router.replace({ path: item.link });
};

onMounted(() => {
  // 搜索栏链接加载
  links.value = loadAll();
});
</script>
<style lang="less" scoped>
.top-navigation {
  height: 100%;
  box-shadow: 0px 0px 3px 1px #f5d8f3;
  background-color: #fff;
  display: flex;
  align-items: center;
}
.navigation-box {
  height: 100%;
  display: flex;
  margin-left: auto;
  justify-content: space-around;
  align-items: center;
}
.topnav-menu-btn {
  background-color: #e675dc;
  background-image: url("@/assets/icons/list.png");
  width: 60px;
  height: 60px;
  background-repeat: no-repeat;
  background-size: 50%;
  background-position: center;
  cursor: pointer;
  float: left;
}
.topnav-company-name {
  font-size: 26px;
  font-weight: bolder;
  display: flex;
  align-items: center;
  height: 100%;
  margin-left: 20px;
}
.search-input {
  width: 500px;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 30px;
  height: 100%;
  min-width: 150px;
}
/* 当父元素宽度小于1300px时，动态调整宽度 */
@media (max-width: 1400px) {
  .search-input {
    width: calc(100vw - 850px); /* 1700px 减去当前视口宽度 */
  }
}
.user-info {
  justify-content: right;
  cursor: pointer;
  padding: 0 10px;
  * {
    margin: 0 10px;
  }
}
.badgets {
  width: 150px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.language {
  margin-right: 10px;
}
</style>
